<template>
<!-- Page Content -->
<div id='page-wrapper'>
  <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل بيانات العميل' spinner='bar-fade-scale' color='#A4A4A4'/>
  <div class='container-fluid'>
    <div class='row'>
      <div class='col-lg-12'>
        <h1 class='page-header'>مراجعة</h1>
      </div>
      <!-- /.col-lg-12 -->
    </div>
    <!-- /.row -->
    <div class='row'>
      <div class='col-lg-12'>
        <div class='panel panel-default'>
          <div class='panel-heading'>
            هنا يتم مراجعة مدخلات النظام للتأكد من صحتها [ الاجمالى {{total}} جنيه] المصروفات {{this.TotalExpenses}} جنيه
            <div class="pull-left">
                <button @click='expenses()' type='button' class='btn btn-outline btn-primary btn-sm btn-block '  data-toggle='modal' data-target='#expenses'>
                المصروفات
                </button>
            </div>
          </div>
          <!-- /.panel-heading -->
          <div class='panel-body'>
            <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
              <ul v-if='validationErrors'>
                <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
              </ul>
            </div>
            <div class="row">
              <div class='col-lg-2 col-md-2 col-sm-6'>
                <label>الفرع</label>
                <select @change="UpdateCollectors()" class="form-control"  v-model="branch_id" >
                  <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class='col-lg-3 col-md-3 col-sm-6'>
                <tbDate :today='today' :mytitle='dateTitle' v-model= 'date' ></tbDate>
              </div>
              <div class='col-lg-3 col-md-3 col-sm-6'>
                <label>المحصل/الفنى:</label>
              <div class="form-group input-group">
                <span class="input-group-btn">
                  <vue-element-loading size='32' :active='isgetTec' spinner='spinner' color='#A4A4A4'/>
                    <button
                      @click="getTec()" class="btn btn-default" type="button"><i class="fa fa-search"></i>
                    </button>
                </span>
                <select @change="changeCollectors()" class="form-control" style="padding: 0px" v-model="collector_id">
                  <option v-for="item in collectors" v-bind:key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
                </div>
              </div>
              <div class='col-lg-2 col-md-2 col-sm-6' >
                <span>&nbsp;</span>
                <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block '>
                عرض
                </button>
              </div>
              <div class='col-lg-2 col-md-2 col-sm-6' >
                <span>&nbsp;</span>
                <button @click='resetFilter()' type='button' class='btn btn-outline btn-primary btn-md btn-block' data-toggle='modal' data-target='#ReviewForm'>
                مصادقة
                </button>
              </div>
            </div>
            <br>
            <div>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>
                    <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>م</th>
                    <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>الكود</th>
                    <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>الاسم</th>
                    <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>الايصال</th>
                    <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>ملاحظات</th>
                    <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>المستخدم</th>
                    <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>الحالة</th>
                    <th colspan=2 style='vertical-align: middle;padding:2px;text-align: center'>العروض</th>
                    <th colspan=3 style='vertical-align: middle;padding:2px;text-align: center'>الصيانة</th>
                    <th colspan=2 style='vertical-align: middle;padding:2px;text-align: center'>سداد اقساط فلتر</th>
                    <th colspan=2 style='vertical-align: middle;padding:2px;text-align: center'>متحصلات</th>
                  </tr>
                  <tr>
                    <th style='padding:2px;text-align: center'>ايصال</th>
                    <th style='padding:2px;text-align: center'>فعلى</th>
                    <th style='padding:2px;text-align: center'>إيصال</th>
                    <th style='padding:2px;text-align: center'>تسليم</th>
                    <th style='padding:2px;text-align: center'>التغيير</th>
                    <th style='padding:2px;text-align: center'>ايصال</th>
                    <th style='padding:2px;text-align: center'>فعلى</th>
                    <th style='padding:2px;text-align: center'>ايصال</th>
                    <th style='padding:2px;text-align: center'>فعلى</th>
                  </tr>
                </thead>
                <tbody>
                  <tr  :class="{fcolorgreen :record.status == 4,deleted :record.status == 3,fcolor :record.status == 1 || record.status == 5}" class='odd gradeX' v-for='(record,index) in records' :key='index'>
                    <td align='center'>{{index +1 }}</td>
                    <td align='center'>{{record.rec_id}}</td>
                    <td style='vertical-align: middle;padding:3px;text-align: right'>{{record.customer_name}}</td>
                    <td style='vertical-align: middle;padding:2px;text-align: center'>{{record.id}}</td>
                    <td style='vertical-align: middle;padding:2px;text-align: right'>{{record.notes}}</td>
                    <td style='vertical-align: middle;padding:2px;text-align: center'>{{record.name}}</td>
                    <td style='vertical-align: middle;padding:2px;text-align: center'>{{record.type}}</td>
                    <td align='center'>
                      <ul style="padding: 0px 16px 0px 0px">
                        <li v-for="item in record.receipt_offers" :key="item.id">
                          {{ item.label }} {{ item.price_type }} {{ item.price }}ج
                        </li>
                      </ul>
                    </td>
                    <td style='vertical-align: middle;padding:2px;text-align: right'>
                      <ul style="padding: 0px 16px 0px 0px">
                        <li v-for="item in record.contract_offers" :key="item.id">
                          {{ item.offer_name }} {{ item.amount }}ج مدفوع:{{ item.paid }}ج
                        </li>
                      </ul>
                    </td>
                    <td align='center'>
                      <ul style="padding: 0px 16px 0px 0px">
                        <li v-for="item in record.receipt_maintenance" :key="item.id">
                          {{ item.label }} {{ item.price }}ج
                        </li>
                      </ul>
                    </td>
                    <td style='vertical-align: middle;padding:2px;text-align: right'>
                      <ul style="padding: 0px 16px 0px 0px">
                        <li v-for="item in record.maintenance_delivery" :key="item.id">
                          {{ item.item }} {{ item.amount }}ج مدفوع:{{ item.paid }}ج
                        </li>
                      </ul>
                    </td>
                    <td style='vertical-align: middle;padding:2px;text-align: right'>
                      <ul style="padding: 0px 16px 0px 0px">
                        <li v-for="item in record.maintenance_installation" :key="item.id">
                          {{ item.item }} {{ item.amount }}ج مدفوع:{{ item.paid }}ج
                        </li>
                      </ul>
                    </td>
                    <td align='center'>
                      <ul style="padding: 0px 16px 0px 0px">
                        <li v-for="item in record.receipt_installation" :key="item.id">
                          {{ item.label }} {{ item.price }}ج
                        </li>
                      </ul>
                    </td>
                    <td style='vertical-align: middle;padding:2px;text-align: right'>
                      <ul style="padding: 0px 16px 0px 0px">
                        <li v-for="item in record.installment_payment_part" :key="item.id">
                          {{ item.due_date }} {{ item.name }} {{ item.payed }}ج
                        </li>
                      </ul>
                      <ul style="padding: 0px 16px 0px 0px">
                        <li v-for="item in record.installment_payment" :key="item.id">
                          {{ item.due_date }} {{ item.name }} {{ item.payed }}ج
                        </li>
                      </ul>
                    </td>
                    <td align='center'>{{record.payed}}</td>
                    <td style='vertical-align: middle;padding:2px;text-align: right'>
                      <ul style="padding: 0px 16px 0px 0px">
                        <li v-for="item in record.receipt" :key="item.id">
                          {{ item.date }} {{ item.tec_name }} {{ item.amount }}ج
                        </li>
                      </ul>
                      <ul style="padding: 0px 16px 0px 0px">
                        <li v-for="item in record.installment_payment" :key="item.id">
                          {{ item.due_date }} {{ item.name }} {{ item.payed }}ج
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /.table-responsive -->
          </div>
          <!-- /.panel-body -->
        </div>
        <!-- /.panel -->
      </div>
      <!-- /.col-lg-12 -->
    </div>
  </div>
  <!-- Collectors Modal -->
  <div class='modal fade' id='ReviewForm' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
    <div class='modal-dialog  modal-lg'>
      <div class='modal-content'>
        <div class='modal-header'>
          <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
          <h4 class='modal-title' id='myModalLabel'>مصادقة اليومية الورقية مع النظام</h4>
        </div>
        <form role='form'>
          <div class='modal-body'>
            <div class='alert alert-danger alert-dismissable' v-if='CollectorsvalidationErrors'>
              <ul v-if='CollectorsvalidationErrors'>
                <li v-for='err in CollectorsvalidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
              </ul>
            </div>
            <div class='alert alert-success alert-dismissable' v-if='CollectorsSuccess'>
              {{CollectorsSuccess}}
            </div>
            <fieldset>
              <div class='form-group col-lg-12 col-sm-12'>
                <label>كود العميل:</label>
                <input v-model='rec_id' class='form-control' name='branchname' type='text'>
              </div>
            </fieldset>
            <div>
                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th style='text-align: center'>الكود</th>
                      <th style='text-align: center'>الاسم</th>
                      <th style='text-align: center'>المبلغ</th>
                      <th style='text-align: center'>المدفوع</th>
                      <th style='text-align: center'>المستخدم</th>
                      <th style='text-align: center'>النوع</th>
                      <th style='text-align: center'>الصنف</th>
                      <th style='text-align: center'>الفنى</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(record,index) in records' :key='index'>
                      <td align='center'>{{record.rec_id}}</td>
                      <td align='center'>{{record.customer_name}}</td>
                      <td align='center'>{{record.amount}}</td>
                      <td align='center'>{{record.payed}}</td>
                      <td align='center'>{{record.name}}</td>
                      <td align='center'>{{record.type}}</td>
                      <td align='center'>{{record.item}}</td>
                      <td align='center'>{{record.tec_name}}</td>
                    </tr>
                  </tbody>
                </table>
            </div>
          </div>
          <div class='modal-footer'>
            <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
          </div>
        </form>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /Collectors modal -->
  <!-- /.container-fluid -->
</div>
</template>
<style>
.fcolor {
   color: #FF0000;
}
.fcolorgreen {
   color: #0BB21A;
}
.deleted {
  text-decoration: line-through;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'DailyReview',
  data () {
    return {
      types: [
        {id: 0, name: 'الكل'},
        {id: 1, name: 'سداد قسط فلتر'},
        {id: 2, name: 'تغيير شمع وسداد'},
        {id: 3, name: 'عرض جديد'},
        {id: 4, name: 'طلب صيانة'}
      ],
      isgetTec: false,
      type_id: 0,
      TotalExpenses: 0,
      total: 0,
      rec_id: null,
      emptyRec: [{id: 0, name: ''}],
      sort: 'cash_receipts.id',
      today: true,
      dateTitle: 'التاريخ',
      date: '',
      validationErrors: '',
      records: [],
      errorShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      CollectorsSuccess: '',
      CollectorsvalidationErrors: '',
      branches: {},
      branch_id: 0,
      modelCollectors: {},
      collectors: {},
      collector_id: 0,
      modelCollectorId: '',
      cashReceipts: '',
      id: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branch_id = JSON.parse(localStorage.getItem('BrancheID'))
    this.UpdateCollectors()
  },
  methods: {
    resetFilter () {
      this.rec_id = null
    },
    UpdateCollectors () {
      this.collector_id = 0
      this.records = ''
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch_id))
      if (i > -1) {
        this.collectors = this.branches[i].collectors
        this.collectors.unshift(this.emptyRec)
      }
    },
    changeCollectors () {
      this.records = ''
    },
    // ========================================================
    getTec () {
      this.isgetTec = true
      axios.post(this.$apiURL + 'get-folder-tec', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        folder_date: this.date
      })
        .then(({ data }) => {
          this.collectors = data
          this.isgetTec = false
        })
        .catch(err => {
          if (err) {
            this.isgetTec = false
          }
        })
    },
    // ========================================================
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'test', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        tec_id: this.collector_id,
        sort: this.sort,
        date: this.date
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ===========================================================
    saveData () {
      let Receipts = []
      this.CollectorsSuccess = ''
      this.CollectorsvalidationErrors = ''
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'set-distributed-receipts', {
        token: localStorage.getItem('token'),
        CollectorId: this.modelCollectorId,
        folderDate: this.folder_date,
        receipts: Receipts
      })
        .then(res => {
          this.isLoadingSave = false
          this.CollectorsSuccess = 'تم الحفظ بنجاح'
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.CollectorsvalidationErrors = err.response.data.errors
          this.isLoadingSave = false
        })
    },
    // ===========================================================
    expenses () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Accounts/Daily/DailyReview1.vue